"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DivScroll = void 0;
var react_1 = __importStar(require("react"));
var request_animation_frame_polyfill_1 = require("request-animation-frame-polyfill");
require("./index.less");
/**
 * 横向滚动
 * @param props
 * @returns
 */
function DivScroll(props) {
    var content = (0, react_1.useRef)(null);
    var step = props.step || -1;
    var max_step = 0;
    var start = 0;
    var stepFun = function () {
        if (content.current) {
            var thiscontent = content.current;
            start += step;
            if (Math.abs(start) >= max_step)
                start = 0;
            thiscontent.style.transform = 'translateX(' + start + 'px)';
            //@ts-ignore
            thiscontent.style.msTransform = 'translateX(' + start + 'px)';
        }
    };
    var animat = function () {
        stepFun();
        thiscd = (0, request_animation_frame_polyfill_1.requestAnimationFrame)(animat);
    };
    var thiscd;
    (0, react_1.useEffect)(function () {
        if (content.current) {
            var thiscontent = content.current;
            max_step = thiscontent.clientWidth / 2;
            animat();
        }
        return function () {
            stop();
        };
    }, [props.children]);
    var stop = function () {
        (0, request_animation_frame_polyfill_1.cancelAnimationFrame)(thiscd);
    };
    var go = function () {
        animat();
    };
    return (react_1.default.createElement("div", { className: "divscroll" },
        react_1.default.createElement("div", { className: "divscroll_c", ref: content, onMouseOver: stop, onMouseLeave: go },
            props.children,
            props.children)));
}
exports.DivScroll = DivScroll;
